import { globalTypes } from "reducers/types/global";

export const types = {
    LIST_STATEMENTS_REQUEST: "corporateCard/LIST_STATEMENTS_REQUEST",
    LIST_STATEMENTS_SUCCESS: "corporateCard/LIST_STATEMENTS_SUCCESS",
    LIST_STATEMENTS_ERROR: "corporateCard/LIST_STATEMENTS_ERROR",
    DOWNLOAD_STATEMENT_REQUEST: "corporateCard/DOWNLOAD_STATEMENT_REQUEST",
    DOWNLOAD_STATEMENT_SUCCESS: "corporateCard/DOWNLOAD_STATEMENT_SUCCESS",
    DOWNLOAD_STATEMENT_ERROR: "corporateCard/DOWNLOAD_STATEMENT_ERROR",
    SET_SELECTED_YEAR: "corporateCard/SET_SELECTED_YEAR",
    SET_LOCAL_PAGE: "corporateCard/SET_LOCAL_PAGE",
    RESET_STATE: "corporateCard/RESET_STATE",
};

export const INITIAL_STATE = {
    statements: [],
    fullStatementsList: [],
    selectedYear: null,
    isFetching: false,
    isDownloading: false,
    downloadingFileName: null,
    error: null,
    pagination: {
        pageNumber: 1,
        totalPages: 0,
        itemsPerPage: 8,
    },
    localPage: 1,
    hasMore: true,
};

export default (state = INITIAL_STATE, action = {}) => {
    const { statements, year, error, fileName } = action;

    switch (action.type) {
        case types.LIST_STATEMENTS_REQUEST:
            return {
                ...state,
                isFetching: true,
                error: null,
            };
        case types.LIST_STATEMENTS_SUCCESS: {
            const allStatements = statements || [];
            const itemsPerPage = state.pagination.itemsPerPage || 8;
            const calculatedTotalPages = Math.ceil(allStatements.length / itemsPerPage);

            return {
                ...state,
                isFetching: false,
                fullStatementsList: allStatements,
                statements: allStatements,
                pagination: {
                    ...state.pagination,
                    pageNumber: 1,
                    totalPages: calculatedTotalPages,
                },
                localPage: 1,
                hasMore: calculatedTotalPages > 1,
                error: null,
            };
        }
        case types.LIST_STATEMENTS_ERROR:
            return {
                ...state,
                isFetching: false,
                error,
                statements: [],
            };
        case types.DOWNLOAD_STATEMENT_REQUEST:
            return {
                ...state,
                isDownloading: true,
                downloadingFileName: fileName,
                error: null,
            };
        case types.DOWNLOAD_STATEMENT_SUCCESS:
            return {
                ...state,
                isDownloading: false,
                downloadingFileName: null,
                error: null,
            };
        case types.DOWNLOAD_STATEMENT_ERROR:
            return {
                ...state,
                isDownloading: false,
                downloadingFileName: null,
                error,
            };
        case types.SET_SELECTED_YEAR:
            return {
                ...state,
                selectedYear: year,
                statements: [],
                fullStatementsList: [],
                pagination: {
                    ...state.pagination,
                    pageNumber: 1,
                    totalPages: 0,
                },
                localPage: 1,
                hasMore: true,
            };
        case types.SET_LOCAL_PAGE:
            return {
                ...state,
                localPage: action.page || 1,
            };
        case types.RESET_STATE:
            return INITIAL_STATE;
        case globalTypes.RESET_SELECTED_ELEMENTS:
        case globalTypes.CLEAN_UP:
            return INITIAL_STATE;
        default:
            return state;
    }
};

export const actions = {
    listStatementsRequest: (year) => ({
        type: types.LIST_STATEMENTS_REQUEST,
        year,
    }),
    listStatementsSuccess: (statements, pageNumber, totalPages) => ({
        type: types.LIST_STATEMENTS_SUCCESS,
        statements,
        pageNumber,
        totalPages,
    }),
    listStatementsError: (error) => ({
        type: types.LIST_STATEMENTS_ERROR,
        error,
    }),
    downloadStatementRequest: (fileName) => ({
        type: types.DOWNLOAD_STATEMENT_REQUEST,
        fileName,
    }),
    downloadStatementSuccess: () => ({
        type: types.DOWNLOAD_STATEMENT_SUCCESS,
    }),
    downloadStatementError: (error) => ({
        type: types.DOWNLOAD_STATEMENT_ERROR,
        error,
    }),
    setSelectedYear: (year) => ({
        type: types.SET_SELECTED_YEAR,
        year,
    }),
    resetState: () => ({
        type: types.RESET_STATE,
    }),
    setLocalPage: (page) => ({
        type: types.SET_LOCAL_PAGE,
        page,
    }),
};

export const selectors = {
    getStatements: ({ corporateCard }) => corporateCard.statements,
    getFullStatementsList: ({ corporateCard }) => corporateCard.fullStatementsList || [],
    getSelectedYear: ({ corporateCard }) => corporateCard.selectedYear,
    getIsFetching: ({ corporateCard }) => corporateCard.isFetching,
    getIsDownloading: ({ corporateCard }) => corporateCard.isDownloading,
    getDownloadingFileName: ({ corporateCard }) => corporateCard.downloadingFileName,
    getError: ({ corporateCard }) => corporateCard.error,
    getPagination: ({ corporateCard }) => corporateCard.pagination,
    getLocalPage: ({ corporateCard }) => corporateCard.localPage || 1,
    getHasMore: ({ corporateCard }) => corporateCard.hasMore,
};
